module.exports = __webpack_public_path__ + "static/media/vector.42f22bee.png";